import { render, staticRenderFns } from "./DocDescIndex.vue?vue&type=template&id=9811a1da&scoped=true"
import script from "./DocDescIndex.vue?vue&type=script&lang=js"
export * from "./DocDescIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9811a1da",
  null
  
)

export default component.exports